// extracted by css-extract-rspack-plugin
export default {"RebaseConfirmationDialog":"RebaseStackConfirmationDialog-module__RebaseConfirmationDialog__hed9f"};